module.exports = __webpack_public_path__ + "static_pc/img/8.25bb385b.png";